import BoundFormGroup from "shared/components/boundForm/BoundFormGroup";

export function RequestResetPasswordFormFeature ({form, onKeyPress}) {
    const fields = [
        [{ id: 'email', placeholder: 'Email', format: 'email', required: true, onKeyPress: onKeyPress }], //
      ];
    return (
        <BoundFormGroup formId={form.id} fields={fields} onKey />
    );
}